import { useContext } from "react";

import { DateFormatContext } from "./DateFormatContext";

export const useDateFormatContext = () => {
  return useContext(DateFormatContext);
};
